<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
	<path
		stroke="currentColor"
		stroke-linecap="round"
		stroke-linejoin="round"
		stroke-width="2"
		d="M1 5.917 5.724 10.5 15 1.5"
	/>
</svg>

<style>
	svg {
    height: 1.5rem;
    width: 1.5rem;
    padding-top: 0.75rem;
    padding-left: 0.5rem;
    --tw-text-opacity: 1;
    color: rgb(74 222 128 / var(--tw-text-opacity, 1))
}
</style>
